import { Directive, HostListener, ElementRef, OnInit } from "@angular/core";
import { CurrencyFormatPipe } from "../pipe/currency-format.pipe";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[currencyFormat]",
})
export class CurrencyFormatDirective {
  private el: any;

  constructor(
    private elementRef: ElementRef,
    private formatcurrencypipe: CurrencyFormatPipe,
    private control: NgControl
  ) {
    this.el = this.elementRef.nativeElement;
  }
  ngOnInit() {
    this.el.value = this.formatcurrencypipe.transform(this.el.value);
  }
  @HostListener("focus", ["$event.target.value", "$event"])
  onFocus(value, event) {
    this.el.value = this.formatcurrencypipe.parse(value); // opossite of transform
    if (event.which == 9) {
      return false;
    }
    this.el.select();
  }

  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {
    if (value == "") {
      this.el.value = null;
    } else {
      this.el.value = this.formatcurrencypipe.transform(value);
    }
  }
  @HostListener("keydown", ["$event"]) onKeyDown(event) {
    let e = <KeyboardEvent>event;
    if (
      [46, 8, 9, 27, 13, 110, 188, 190].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  }
  @HostListener("paste", ["$event"])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    let pasted_number = +this.formatcurrencypipe.parse(event.clipboardData.getData("text/plain"));
    this.el.value = pasted_number;
    this.control?.control?.setValue(pasted_number);
  }

  @HostListener("ngModelChange", ["$event"]) onChange(value) {
    this.el.value = this.formatcurrencypipe.transform(value);
  }
}
